const { ccclass, property } = cc._decorator;
import BaseTableModel from "./base_table_model";
import * as ProtoGame from "../../net/proto/longhudou_proto_game"
import NetMsgData from "../../net/longhudou_net_msg_data_game"
import * as RoomProto from "../../net/proto/longhudou_room"

@ccclass
export default class LongHuDouModel extends BaseTableModel {

    //离开房间请求
    request_leave_room(){
        let protoData: RoomProto.LongHuDouRoom.ILeaveReq = {
        }
        this.sendMsg(NetMsgData.LeaveRoom, protoData)
    }

    //押注请求 area 押注区域(1:龙 2:虎 3:和)
    request_bet(area: number, type: number){
        let protoData: ProtoGame.LongHuDou.IBetReq = {
            area: area,
            type: type,
        }
        this.sendMsg(NetMsgData.BetReq, protoData)
    }
    
    //请求历史数据
    request_history_result(){
        let protoData: ProtoGame.LongHuDou.IBetResultHistory = {
        }
        this.sendMsg(NetMsgData.GetHistoryResult, protoData)
    }

    //请求在线玩家
    request_online_players(){
        let protoData: ProtoGame.LongHuDou.IOnlinePlayersReq = {
        }
        this.sendMsg(NetMsgData.GetOnlinePlayers, protoData)
    }

    //上下庄请求1上庄 2下庄
    request_hold_banker(type: number){
        if (type == 1 || type == 2){
            let protoData: ProtoGame.LongHuDou.IBankerReq = {
                type: type,
            }
            this.sendMsg(NetMsgData.BankerReq, protoData)
        }
    }
}